import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, change as changeAction } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import ContentSave from 'material-ui/svg-icons/content/save';
import compose from 'recompose/compose';

import FormField from 'components/form/FormField';
import { SelectInput } from 'components/input';

import { required } from 'components/form/validate';
import getDefaultValues from 'components/form/getDefaultValues';

import { 
  crudCreate as crudCreateAction,
  crudUpdate as crudUpdateAction,
} from 'actions/dataActions';

import * as urls from '../urls';
import * as utils from '../utils';


const form_id = 'trigger-create-form';

class TriggerCreateBase extends Component {
  handleSubmit = () => {
    const { formValues } = this.props;

    if (this.props._record) {
      this.props.crudUpdate(
        utils.PromotionTriggerResourceName,
        this.props._record.id,
        {
          promotion: this.props.promotion_id,
          product: formValues.product || '',
          benefit: formValues.benefit || '',
          is_active: true,
        },
        {
          promotion: this.props.promotion_id,
          product: String(this.props._record.product.id),
          benefit: String(this.props._record.benefit.id),
          is_active: this.props._record.is_active,
        },
        urls.promotionTriggerBackendPath,
        '',
        'Trigger has been updated',
        () => {
          this.props.refresh();
          this.props.closeDialog();
        }
      );
    } else {
      this.props.crudCreate(
        utils.PromotionTriggerResourceName,
        {
          promotion: this.props.promotion_id,
          product: formValues.product || '',
          benefit: formValues.benefit || '',
          is_active: true,
        },
        urls.promotionTriggerBackendPath,
        '',
        false,
        () => {
          this.props.refresh();
          this.props.closeDialog();
        }
      );
    }
  }


  onCategoryChange = (_, value) => {
    this.props.change('product', '');
    this.props.change('benefit', '');
  };

  componentDidMount() {
    if (this.props._record) {
      const _product = this.props._record.product;
      this.props.change('category', _product.category);
      this.props.change('product', String(_product.id));
      this.props.change('benefit', String(this.props._record.benefit.id));
    }
  }

  render() {
    const { resource, record, formValues, products, benefits } = this.props;
    const current_category = formValues.category || {};
    const category_choices = utils.PRODUCT_CATEGORY_CHOICES_TH;
    const product_choices = Object.keys(products)
    // eslint-disable-next-line
    .filter(product_id => (!current_category || products[product_id].category == current_category))
    .map((product_id) => ({
      id: product_id,
      name: products[product_id].en,
    }));
    const benefit_choices = Object.keys(benefits).map((benefit_id) => ({
      id: benefit_id,
      name: `${benefits[benefit_id].category} - ${benefits[benefit_id].parameter}`,
    }));

    return (
      <form onSubmit={this.handleSubmit} className="simple-form">
        <div style={{ padding: '0 1em 1em 1em' }}>
          <div key='category' className={'aor-input-category'}>
            <FormField
              input={
                <SelectInput
                  source='category'
                  label='Category'
                  choices={category_choices}
                  isRequired={true}
                  allowEmpty={false}
                  onChange={this.onCategoryChange}
                />
              }
            
              isRequired={true}
              resource={resource}
              record={record}
              validate={[required]}
            />
          </div>
          <div key='product' className={'aor-input-product'}>
            <FormField
              input={
                <SelectInput
                  source='product'
                  label='Product'
                  choices={product_choices}
                  isRequired={true}
                  allowEmpty={false}
                  disabled={!product_choices.length}
                />
              }
              disabled={!current_category}
              isRequired={true}
              resource={resource}
              record={record}
              validate={[required]}
            />
          </div>
          <div key='benefit' className={'aor-input-benefit'}>
            <FormField
              input={
                <SelectInput
                  source='benefit'
                  label='Benefit'
                  choices={benefit_choices}
                  isRequired={true}
                  allowEmpty={false}
                />
              }
              disabled={!current_category}
              isRequired={true}
              resource={resource}
              record={record}
              validate={[required]}
            />
          </div>

          <RaisedButton
            disabled={!!this.props.submitting}
            type={'submit'}
            label={'Save'}
            icon={this.props.submitting ? <CircularProgress size={25} thickness={2} /> : <ContentSave />}
            primary={!this.props.submitting}
            style={{
              margin: '30px 0 0',
            }}
            onClick={(e) => {
              e.preventDefault();
              this.handleSubmit();
            }}
          />

          <FlatButton
            disabled={!!this.props.submitting}
            label={'Cancel'}
            style={{
              margin: '30px 30px 0',
            }}
            onClick={(e) => {
              e.preventDefault();
              this.props.closeDialog();
            }}
          />
        </div>
      </form>
    );
  }
}

const enhanceInit = compose(
  connect(
    (state, props) => ({
      initialValues: getDefaultValues(state, props),
      submitFailed: (state.form[form_id] || {}).submitFailed,
      syncErrors: ((state.form[form_id] || {}).syncErrors || {}),
      formValues: ((state.form[form_id] || {}).values || {}),
    }),
    {
      crudCreate: crudCreateAction,
      crudUpdate: crudUpdateAction,
      change: changeAction,
    },
  ),
  reduxForm({
    form: form_id,
    enableReinitialize: false,
  }),
);

export const TriggerCreateTH = enhanceInit(TriggerCreateBase);



// WEBPACK FOOTER //
// ./src/routes/product/PromotionEdit/TriggerCreateTH.js